export const categories = [
  {
    id: 1,
    slug: "beauty",
    name: "美妆护肤",
    desc: "从素颜出镜到全妆上阵，妆容细节的变化最容易被一眼看穿。",
    icon: "ri-magic-line",
    count: 42,
  },
  {
    id: 2,
    slug: "fashion",
    name: "穿搭时尚",
    desc: "面料、剪裁与配色的升级，往往比五官更能撑起一个人的气场。",
    icon: "ri-shirt-line",
    count: 36,
  },
  {
    id: 3,
    slug: "food",
    name: "美食探店",
    desc: "镜头前的松弛感是怎么练出来的？这一栏看氛围感的养成。",
    icon: "ri-restaurant-2-line",
    count: 28,
  },
  {
    id: 4,
    slug: "knowledge",
    name: "知识科普",
    desc: "同一张脸的讲解气质，随着内容沉淀而发生的微妙转变。",
    icon: "ri-book-open-line",
    count: 21,
  },
  {
    id: 5,
    slug: "travel",
    name: "旅行户外",
    desc: "从随手一拍的游客照，到有构图意识的人像大片。",
    icon: "ri-road-map-line",
    count: 25,
  },
  {
    id: 6,
    slug: "fitness",
    name: "健身运动",
    desc: "体态与精神面貌的长期积累，是最经得起对照的一类变化。",
    icon: "ri-run-line",
    count: 19,
  },
  {
    id: 7,
    slug: "comedy",
    name: "剧情搞笑",
    desc: "为角色服务的造型切换，常常藏着最鲜活的成长轨迹。",
    icon: "ri-emotion-laugh-line",
    count: 23,
  },
  {
    id: 8,
    slug: "digital",
    name: "数码科技",
    desc: "从出租屋背景到专业布光，硬件的提升也写在画面里。",
    icon: "ri-device-line",
    count: 17,
  },
];